// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--svg-gradient-care {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #000;
}

.scl--svg-gradient-care__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  filter: blur(10px);

  /* optional but recommended */
  transform: translateZ(0);
  will-change: transform;
}

.scl--svg-gradient-care::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;

  background:
    /* Side vignette */
    radial-gradient(
      ellipse at center,
      rgba(0, 0, 0, 0.3) 10%
    ),
    /* Bottom darkening */
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(18, 8, 6, 0.45) 38%,
      rgba(14, 6, 4, 0.75) 58%,
      rgba(8, 3, 2, 0.92) 78%,
      rgba(0, 0, 0, 0.98) 100%
    );
}

`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/career/css/careerGradient.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;;EAElB,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;;EAEpB;;;;;;;;;;;;;;KAcG;AACL","sourcesContent":[".scl--svg-gradient-care {\n  position: relative;\n  min-height: 100vh;\n  overflow: hidden;\n  background: #000;\n}\n\n.scl--svg-gradient-care__bg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  filter: blur(10px);\n\n  /* optional but recommended */\n  transform: translateZ(0);\n  will-change: transform;\n}\n\n.scl--svg-gradient-care::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n\n  background:\n    /* Side vignette */\n    radial-gradient(\n      ellipse at center,\n      rgba(0, 0, 0, 0.3) 10%\n    ),\n    /* Bottom darkening */\n    linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0) 0%,\n      rgba(18, 8, 6, 0.45) 38%,\n      rgba(14, 6, 4, 0.75) 58%,\n      rgba(8, 3, 2, 0.92) 78%,\n      rgba(0, 0, 0, 0.98) 100%\n    );\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
